import type { PermissionStatus } from '@lia/contracts';
import * as React from 'react';
import { StatusBadge } from '../primitives/badge.js';
import { PERMISSION_STATUS_TONE } from './status.js';

export const PERMISSION_STATUS_LABELS: Record<PermissionStatus, string> = {
  granted: 'Permiso otorgado',
  denied: 'Permiso negado',
  revoked: 'Permiso revocado',
  unknown: 'Permiso desconocido',
};

export interface PermissionBadgeProps {
  /** Channel the permission applies to, e.g. "WhatsApp" or "Llamadas". */
  channel: string;
  status: PermissionStatus;
  className?: string;
}

/** Contact permission (consent) for one channel: tone + icon + text. */
export const PermissionBadge = React.forwardRef<
  HTMLSpanElement,
  PermissionBadgeProps
>(function PermissionBadge({ channel, status, className }, ref) {
  return (
    <StatusBadge
      ref={ref}
      tone={PERMISSION_STATUS_TONE[status]}
      className={className}
    >
      {channel}: {PERMISSION_STATUS_LABELS[status].toLowerCase()}
    </StatusBadge>
  );
});
